import type { ItemResumo } from '@sc/shared/triagem';

/** O que a pessoa informou, para conferir antes de enviar o contato. A pontuação nunca aparece aqui. */
export function ResumoCard({ itens }: { itens: ItemResumo[] }) {
  return (
    <section className="chat-resumo" aria-label="Resumo do seu pedido">
      <h3>Resumo do seu pedido</h3>
      <dl>
        {itens.map((i) => (
          <div key={i.rotulo}>
            <dt>{i.rotulo}</dt>
            <dd>{i.valor}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
